import React, { Component, Fragment } from 'react';
import Raven from 'raven-js';
import { Icon, Button, Container } from 'semantic-ui-react';

import { hlog } from '../common/util';
import { CONFIG } from '../../config';

const enableRaven = process.env.REACT_APP_SERVER_TARGET !== 'cn';
if (enableRaven) {
  if (CONFIG.DEV) {
    Raven.config('https://0fcf9c38caa84e9dbc0583c7e1a423e0@sentry.io/1221094').install();
  } else {
    Raven.config('https://d847d15f1b264862a3c48a8182cb42f8@sentry.io/157011').install();
  }
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    hlog(error);
    hlog(errorInfo);
    if (enableRaven) {
      Raven.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <Fragment>
          <Container>
            <nav id='header'>
              <a href='/' className='logo-hackhub'>
                <img
                  src='/img/general/logo-blue.png'
                  alt='HackHub'
                  title='HackHub'
                />
              </a>
            </nav>
          </Container>
          <section className='pageError'>
            <Icon name='tv-retro' />
            <h1 className='pageError_heading'>Oops! Something went wrong.</h1>
            <p className='pageError_message'>
              {"This page didn't load correctly. Please "}
              <a
                href='mailto:info@hackhub.com'
                className='pageError_link'
              >
                Contact Us
              </a>
            </p>
            <Button
              as='a'
              primary
              href='/'
              size='large'
              className=' pageError_link'
            >
              Go Back Home
            </Button>
          </section>
        </Fragment>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/errorBoundary/index.js